<template>
    <div v-if="accessInfoGeneral">
      <form class="matriculation-form" @submit.prevent="getData(true, true)">
        <ba-search name="matriculation" placeholder="Immatriculation" v-model.trim="matriculationSearch"></ba-search>
      </form>
      <ba-search-card legend="Recherche">
        <form @submit.prevent="handleFilterResults">
          <div class="cols">
            <div class="col-4">
              <ba-select label="Type de pièce" :allow-empty="true" :empty-label="'Moteur & Boîte'" v-model="document_type">
                <option :value="type.id" v-for="(type, index) in types" :key="`type_${index}`">{{ type.name }}</option>
              </ba-select>
            </div>
            <div class="col-4"><ba-input type="text" label="Marque" v-model="brand"></ba-input></div>
            <div class="col-4"><ba-input type="text" label="Modèle" v-model="version"></ba-input></div>
            <div class="col-4">
              <ba-select label="Energie" :allow-empty="true" :empty-label="'Tous'" v-model="energy">
                <option v-for="(energy, index) in energies" :value="energy.name" :key="index">{{ energy.name }}</option>
              </ba-select>
            </div>

            <div class="col-4">
              <ba-select label="Etat" :allow-empty="true" :empty-label="'Tous'" v-model="status_document">
                <option :value="row.id" v-for="(row, index) in status" :key="'status-'+index">{{ row.label }}</option>
              </ba-select>
            </div>
            <div class="col-4"><ba-input type="text" label="Type moteur" v-model="motor_type"></ba-input></div>
            <div class="col-4"><ba-input type="text" label="Type boîte" v-model="gearbox_type"></ba-input></div>
            <div class="col-4"><ba-input type="text" label="Type Mine / Cnit" v-model="cnit"></ba-input></div>

            <div class="col-4"><ba-input type="text" label="Ktype" v-model="ktype"></ba-input></div>
			<div class="col-4"><ba-input type="text" label="Adaptabilité moteur" v-model="motor_adapt"></ba-input></div>
            <div class="col-4"><ba-input type="text" label="Adaptabilité boîte" v-model="gearbox_adapt"></ba-input></div>

            <div class="col-4"><ba-input type="text" label="Identifiant fiche article" v-model="document_id"></ba-input></div>
            <div class="col-4">
              <ba-select label="Type Mine / Cnit en attente" :allow-empty="true" :empty-label="'Tous'" v-model="cnit_mine_status">
                <option v-for="(status, idx) in cnitMineStatus" :value="status.id" :key="`status-cnit-mine-${idx}`">{{ status.label }}</option>
              </ba-select>
            </div>
            <div class="search-buttons-ctn flex flex-end">
            <div class="tooltip-container">
                <div @click="handleExport"><ab-icon icon="excel"></ab-icon></div>
                <div class="tooltip">
                  {{ $t('action.export') }}
                </div>
            </div>
              <div class="buttons-container flex flex-end">
                <div class="tooltip-container">
                    <div @click="handleResetFilter"><ab-icon class="refresh" icon="refresh"></ab-icon></div>
                    <div class="tooltip">
                      {{ $t('action.resetFilter') }}
                    </div>
                </div>
                <ba-button class="primary" :disabled="filterOnGoing">{{ $t('action.search') }}</ba-button>
              </div>
            </div>
          </div>
        </form>
      </ba-search-card>

      <div class="document-button buttons-container flex flex-space">
        <div><span v-if="documentsCount && documentsCount != counter">{{ documentsCount }} sur </span>{{ counter }} {{ $t('text.documents') }}</div>
        <router-link :to="{ name: 'DocumentCreate' }" class="btn-action secondary" v-if="accessCreationFa">{{ $t('action.newDocument') }}</router-link>
      </div>

      <div class="loading" v-if="loading">
        <mo-loader :loading="loading"></mo-loader>
      </div>
      <ba-table v-if="documents.length && !loading">
        <template slot="colgroup">
          <col>
          <col class="brand">
          <col>
          <col>
          <col>
          <col>
          <col>
          <col>
          <col>
          <col>
          <col>
        </template>
        <template slot="body">
          <tr v-for="(document, index) in documents" :key="index">
            <td><img class="img-fit" :src="handleGetBrandImage(document.aaa_brand)" @error='defaultImage' /></td>
            <td class="brand-data">{{ document.aaa_brand }} {{ document.aaa_model }}<span class="subelement">{{ document.aaa_energy }} - {{ document.tecdoc_date_min | dateYear }}</span><span class="subelement">{{ $t('text.id') }} {{ document.doc_id || document.id }}</span></td>
            <td>
              <ul class="motor-gearbox">
                <li v-for="motor in getTypeAdaptability(document.motor_type)">
                  {{ motor }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="motor-gearbox">
                <li v-for="motor in getTypeAdaptability(document.motor_adapt)">
                  {{ motor }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="motor-gearbox">
                <li v-for="gearbox in getTypeAdaptability(document.gearbox_type)">
                  {{ gearbox }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="motor-gearbox">
                <li v-for="gearbox in getTypeAdaptability(document.gearbox_adapt)">

                  {{ gearbox }}
                </li>
              </ul>
            </td>
            <td>{{ document.aaa_steam_power }}</td>
            <td>{{ document.aaa_fiscal_power }}</td>
            <td>{{ document.aaa_gearbox }}<span class="subelement">{{ document.aaa_gear_number }}</span></td>
            <td>{{ document.view }} {{ document.view == 1 ? `vue` : `vues` }}</td>
            <td><span v-if="document.cnit_mine_counter > 0">{{ document.cnit_mine_counter }}</span></td>
            <td>
              <ba-state-label
                :statut="getStatusColor(document.status_document_label)"
                :label="document.status_document_label"
                v-if="document.status_document_label"
              >
              </ba-state-label>
              <mo-speedometer
                :defaultImg="`/img/request/speedometer-${getSpeedometerLabel(document.note)}.png`"
                :hoverImg="'/img/request/speedometer-hover.png'"
                :value="document.note"
                class="speedometer"
                v-if="document.note"
              ></mo-speedometer>
            </td>
            <td class="more filter-link flex flex-end">
              <div class="flex items-center">
                <div class="tooltip-container" v-if="accessModifFa">
                    <router-link :to="{ name: 'DocumentEdit', params: { id: document.doc_id ? document.doc_id : document.id }}" class="item"><ab-icon icon="edit" iconset="documentgeneral"></ab-icon></router-link>
                    <div class="tooltip">
                        {{ $t('action.edit') }}
                    </div>
                </div>
                <div class="tooltip-container" v-if="accessSuppressionFa">
                  <span class="item" @click="showModal(document.doc_id ? document.doc_id : document.id)"><ab-icon icon="delete" class="delete" iconset="documentgeneral"></ab-icon></span>
                  <div class="tooltip">
                      {{ $t('action.delete') }}
                  </div>
                </div>
                <div class="tooltip-container" v-if="document.status_document_label == 'Validé'">
                  <span @click="handleUpdateDocumentStatus(document.doc_id ? document.doc_id : document.id, 2)" class="item" ><ab-icon icon="validate" class="validate" iconset="documentgeneral"></ab-icon></span>
                  <div class="tooltip">
                      {{ $t('action.validate') }}
                  </div>
                </div>
                <div class="tooltip-container" v-else>
                  <span @click="handleUpdateDocumentStatus(document.doc_id ? document.doc_id : document.id, 1)" class="item" ><ab-icon icon="unValidate" class="unValidate"  iconset="documentgeneral"></ab-icon></span>
                  <div class="tooltip">
                      {{ $t('action.unvalidate') }}
                  </div>
                </div>
              </div>
              <div class="tooltip-container">
                  <router-link :to="{ name: 'DocumentDetails', params: { id: document.doc_id ? document.doc_id : document.id }}" class="item"><ab-icon icon="moreDetails" iconset="documentgeneral"></ab-icon></router-link>
                  <div class="tooltip">
                      {{ $t('action.moreDetails') }}
                  </div>
              </div>
              <div v-if="userRole == 'Seller' || userRole == 'Partner'">
                  <router-link :to="{ name: 'DocumentDetails', params: { id: document.doc_id ? document.doc_id : document.id }}" class="item">{{ $t('action.moreDetails') }}</router-link>
              </div>
            </td>
          </tr>
        </template>
        <template slot="head">
          <tr>
            <th :class="[col.class, col.sortable ? 'sortable': '']" v-for="(col, index) in cols" :key="index" @click="sortby(index)">
              <span>{{ col.label }}<ab-icon :icon="ordercol(index)" v-if="col.sortable && ordercol(index)"></ab-icon></span>
            </th>
          </tr>
        </template>
      </ba-table>
      <div v-if="!documents.length && !loading">
        <p class="no-data">{{ $t('text.noDocumentsAvailable') }}</p>
      </div>
        <footer class="mt12">
      <paginate
        :pageCount="pageCount(documents)"
        prev-class="prev"
        next-class="next"
        prev-text=" < "
        next-text=" > "
        v-model="currentPage"
        v-if="documents.length && !loading"
        :containerClass="'mo-pagination'">
      </paginate>
    </footer>

     <!-- EXPORT FILE MODAL -->
    <modal class="modal" name="download" width="376px">
      <ba-card>
        <template slot="header">
          <span>{{ $t('sectionTitle.download') }}</span>
        </template>
        <template>
          <p>{{ $t('modal.documentReadyForDownload') }}</p>
        </template>
        <template slot="footer">
          <div class="buttons-container flex flex-center">
            <a class="btn-action primary"
              :href="download.href"
              target="_blank"
              :download="download.file"
              @click="$modal.hide('download')">
              {{ $t('action.download') }}
            </a>
          </div>
        </template>
      </ba-card>
    </modal>

    <modal class="modal" name="removeDocument" width="376px" @before-open="beforeOpen">
      <ba-card>
        <template slot="header">
          <span>{{ $t('sectionTitle.removeDocument') }}</span>
        </template>
        <template>
          <p>{{ $t('modal.removeDocument') }}</p>
        </template>
        <template slot="footer">
          <div class="buttons-container flex flex-end">
            <ba-button class="primary" @click.native="closeModal">{{ $t('action.cancel') }}</ba-button>
            <ba-button class="danger" @click.native="handleRemoveDocument">{{ $t('action.confirm') }}</ba-button>
          </div>
        </template>
      </ba-card>
    </modal>
    <ab-iconset iconset="documentgeneral">
      <g id="edit">
        <path d="M21.9632 1.07832C20.5253 -0.35944 18.1941 -0.35944 16.7562 1.07832L2.15936 15.6739C2.05933 15.7739 1.9871 15.8979 1.94939 16.034L0.0298562 22.9634C-0.0490855 23.2475 0.0311345 23.5517 0.239515 23.7604C0.448215 23.9687 0.752476 24.0489 1.0366 23.9703L7.96653 22.0507C8.10268 22.0129 8.22669 21.9407 8.32672 21.8407L22.9233 7.24481C24.3589 5.80609 24.3589 3.47704 22.9233 2.03832L21.9632 1.07832ZM3.9421 16.2057L15.8885 4.26L19.7413 8.11245L7.79459 20.0581L3.9421 16.2057ZM3.1725 17.7498L6.25059 20.828L1.99285 22.0075L3.1725 17.7498ZM21.7663 6.08796L20.8986 6.9556L17.0455 3.10282L17.9135 2.23518C18.7122 1.43656 20.0072 1.43656 20.8059 2.23518L21.7663 3.19518C22.5637 3.99475 22.5637 5.2887 21.7663 6.08796Z" />
      </g>
      <g id="delete">
        <path d="M19.875 3H15.75V2.25C15.75 1.00936 14.7406 0 13.5 0H10.5C9.25936 0 8.25 1.00936 8.25 2.25V3H4.125C3.09113 3 2.25 3.84113 2.25 4.875V7.5C2.25 7.91419 2.58581 8.25 3 8.25H3.40988L4.05783 21.857C4.11506 23.0587 5.10225 24 6.30525 24H17.6947C18.8978 24 19.885 23.0587 19.9422 21.857L20.5901 8.25H21C21.4142 8.25 21.75 7.91419 21.75 7.5V4.875C21.75 3.84113 20.9089 3 19.875 3ZM9.75 2.25C9.75 1.83647 10.0865 1.5 10.5 1.5H13.5C13.9135 1.5 14.25 1.83647 14.25 2.25V3H9.75V2.25ZM3.75 4.875C3.75 4.66823 3.91823 4.5 4.125 4.5H19.875C20.0818 4.5 20.25 4.66823 20.25 4.875V6.75C20.0189 6.75 4.7078 6.75 3.75 6.75V4.875ZM18.4439 21.7857C18.4248 22.1862 18.0957 22.5 17.6947 22.5H6.30525C5.90423 22.5 5.57517 22.1862 5.55614 21.7857L4.91156 8.25H19.0884L18.4439 21.7857Z" />
        <path d="M12 21C12.4142 21 12.75 20.6642 12.75 20.25V10.5C12.75 10.0858 12.4142 9.75 12 9.75C11.5858 9.75 11.25 10.0858 11.25 10.5V20.25C11.25 20.6642 11.5858 21 12 21Z" />
        <path d="M15.75 21C16.1642 21 16.5 20.6642 16.5 20.25V10.5C16.5 10.0858 16.1642 9.75 15.75 9.75C15.3358 9.75 15 10.0858 15 10.5V20.25C15 20.6642 15.3358 21 15.75 21Z" />
        <path d="M8.25 21C8.66419 21 9 20.6642 9 20.25V10.5C9 10.0858 8.66419 9.75 8.25 9.75C7.83581 9.75 7.5 10.0858 7.5 10.5V20.25C7.5 20.6642 7.83577 21 8.25 21Z" />
      </g>
      <g id="unValidate">
        <path d="M17.6484 5.64844H6.35153C2.84926 5.64844 0 8.49779 0 12C0 15.5022 2.84926 18.3516 6.35153 18.3516H17.6484C21.1507 18.3516 24 15.5023 24 12C24 8.49774 21.1507 5.64844 17.6484 5.64844ZM6.35153 16.9454C3.62466 16.9454 1.40625 14.7269 1.40625 12C1.40625 9.27315 3.62466 7.05469 6.35153 7.05469C9.07839 7.05469 11.2969 9.27315 11.2969 12C11.2969 14.7269 9.07839 16.9454 6.35153 16.9454Z" />
      </g>
      <g id="validate">
        <path d="M17.6484 5.64844H6.35156C2.8493 5.64844 0 8.49773 0 12C0 15.5023 2.8493 18.3516 6.35156 18.3516H17.6484C21.1507 18.3516 24 15.5023 24 12C24 8.49773 21.1507 5.64844 17.6484 5.64844ZM17.6484 16.9453C14.9216 16.9453 12.7031 14.7269 12.7031 12C12.7031 9.27319 14.9216 7.05469 17.6484 7.05469C20.3753 7.05469 22.5938 9.27319 22.5938 12C22.5938 14.7269 20.3753 16.9453 17.6484 16.9453Z" />
      </g>
      <g id="moreDetails">
        <path d="M16.9257 3.24933H16.356V17.6286C16.356 18.5834 15.5989 19.361 14.6695 19.361H4.30646V19.8942C4.30646 20.5045 4.78868 21.0001 5.38273 21.0001H16.9235C17.5178 21.0001 18 20.5045 18 19.8942V4.35488C18.0002 3.74444 17.5197 3.24933 16.9257 3.24933Z" fill="#024089"/>
        <path d="M8.84477 18.7603H14.6149C15.2092 18.7603 15.6914 18.2652 15.6914 17.6549V2.11544C15.6914 1.505 15.2092 1.0096 14.6149 1.0096H6.92596V1.37565C6.92984 1.41331 6.93214 1.45288 6.93214 1.49245V4.52129C6.93214 5.38039 6.25243 6.07883 5.4162 6.07883H2.46813C2.43751 6.07883 2.40475 6.07632 2.37442 6.0744H2V17.6551C2 18.2654 2.48222 18.7605 3.07655 18.7605H8.84477V18.7603ZM9.06239 15.0022H5.30035C5.01936 15.0022 4.7914 14.7681 4.7914 14.4792C4.7914 14.1908 5.01936 13.9567 5.30035 13.9567H9.06439C9.34539 13.9567 9.57306 14.1908 9.57306 14.4792C9.57306 14.7681 9.3431 15.0022 9.06239 15.0022ZM12.8269 12.335H5.30035C5.01936 12.335 4.7914 12.1009 4.7914 11.8125C4.7914 11.5237 5.01936 11.2895 5.30035 11.2895H12.8269C13.1076 11.2895 13.3352 11.5236 13.3352 11.8125C13.3354 12.1009 13.1077 12.335 12.8269 12.335ZM5.30035 8.45707H12.8269C13.1076 8.45707 13.3352 8.69111 13.3352 8.98009C13.3352 9.26847 13.1076 9.50252 12.8269 9.50252H5.30035C5.01936 9.50252 4.7914 9.26847 4.7914 8.98009C4.7914 8.69126 5.01936 8.45707 5.30035 8.45707Z" fill="#024089"/>
        <path d="M2.52016 5.42513H5.46838C5.47039 5.42513 5.47427 5.42513 5.47657 5.42513C5.969 5.42114 6.36785 5.01123 6.37188 4.50534C6.37188 4.50342 6.37188 4.49899 6.37188 4.49707V1.46617C6.37188 1.1862 6.14808 1 5.91624 1C5.80428 1 5.69245 1.04208 5.59874 1.13792L2.19863 4.63115C1.91375 4.92367 2.11513 5.42513 2.52016 5.42513Z" fill="#024089"/>
        <circle cx="15.5" cy="16.5" r="6.00002" fill="#024089" stroke="white"/>
        <path d="M18.6012 15.8082H16.1899V13.3989C16.1899 13.0176 15.8822 12.7084 15.5008 12.7084C15.1195 12.7084 14.812 13.0176 14.812 13.3991V15.8099H12.3995C12.0181 15.8099 11.7081 16.1191 11.7083 16.5006C11.7081 16.6912 11.7851 16.866 11.9099 16.9907C12.0348 17.1159 12.2072 17.1949 12.3976 17.1949H14.812V19.6023C14.812 19.7931 14.8876 19.9658 15.0126 20.0904C15.1375 20.2154 15.3094 20.2927 15.5002 20.2927C15.8814 20.2927 16.1899 19.9835 16.1899 19.6023V17.1947H18.6012C18.9826 17.1947 19.2918 16.8828 19.2916 16.5015C19.2914 16.1203 18.9822 15.8082 18.6012 15.8082Z" fill="white"/>
      </g>
    </ab-iconset>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Paginate from 'vuejs-paginate';
import { AbIcon, AbIconset, BaButton, BaCard, BaDropdown, BaInput, BaSearch, BaSearchCard, BaSelect, BaStateLabel, BaTable } from '@ab/basic-components';
import MoLoader from '@/components/loader/mo-loader.vue';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';
import MoSpeedometer from '@/components/tool/mo-speedometer.vue';

import paginationMixin from '@/components/mixins/pagination.js';
import requestMixin from '@/components/mixins/request.js';
import searchMixin from '@/components/mixins/search.js';
import sortableMixin from '@/components/mixins/sortable.js';
import { generateSearchWatcher } from '@/assets/js/helpers.js';

export default {
  name: 'DocumentList-general',
  components: {
    AbIcon,
    AbIconset,
    BaButton,
    BaCard,
    BaDropdown,
    BaInput,
    BaSearch,
    BaSearchCard,
    BaSelect,
    BaStateLabel,
    BaTable,
    MoLoader,
    MoPageheader,
    MoSpeedometer,
    Paginate,
  },
  mixins: [ paginationMixin, requestMixin, searchMixin, sortableMixin ],
  async mounted() {
    /* Get documents counter */
    await this.$store.dispatch('getDocumentCounter');
    /* Get energies to fill dedicated search options */
    await this.$store.dispatch('getEnergies');
    /* Get document status */
    await this.$store.dispatch('getDocumentStatus');
    await this.$store.dispatch('getDocumentTypes');

    this.accessInfoGeneral = await this.$store.dispatch('getAccesRole', {search:10,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});

    this.accessValidFicheArticle = await this.$store.dispatch('getAccesRole', {search:13,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});    

    this.accessCreationFa = await this.$store.dispatch('getAccesRole', {search:7,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});   

    this.accessModifFa = await this.$store.dispatch('getAccesRole', {search:8,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});   

    this.accessSuppressionFa = await this.$store.dispatch('getAccesRole', {search:11,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});           
  },
  data() {
    return {
      accessInfoGeneral: false,
      accessValidFicheArticle: false,
      accessCreationFa: false,
      accessModifFa: false,
      accessSuppressionFa: false,
      stateFicheArticle:'general',
      userRole: this.$store.getters.getUserRole,
      documentId: '',
      documentsCount: '',
      filterOnGoing: false,
      cnitMineStatus: [
        { id: 1, label: 'Non' },
        { id: 2, label: 'Oui' },
      ],
      download: {
        href: '',
        file: ''
      },
      matriculationSearch: '',
      ...this.generateSearchData([
        'brand',
        'ktype',
        'cnit',
        'cnit_mine_status',
        'document_id',
        'document_type',
        'energy',
        'gearbox_type',
        'motor_type',
        'status_document',
        'version',
		'gearbox_adapt',
        'motor_adapt',

      ]),
      cols: [
        { label: '', sortable: false, sorted: '', key: '', class: '' },
        { label: 'Véhicule', sortable: true, sorted: '', key: 'aaa_brand', class: '' },
        { label: 'Type moteur', sortable: true, sorted: '', key: 'motor_type', class: '' },
        { label: 'Adaptabilité moteur', sortable: true, sorted: '', key: 'motor_adapt', class: '' },
        { label: 'Type boîte', sortable: true, sorted: '', key: 'gearbox_type', class: '' },
        { label: 'Adaptabilité boîte', sortable: true, sorted: '', key: 'gearbox_adapt', class: '' },
        { label: 'Puissance Ch.', sortable: true, sorted: '', key: 'aaa_steam_power', class: '' },
        { label: 'Puissance Fis.', sortable: true, sorted: '', key: 'aaa_fiscal_power', class: '' },
        { label: 'Boîte de vitesses', sortable: true, sorted: '', key: 'aaa_gearbox', class: '' },
        { label: 'Vues', sortable: true, sorted: '', key: 'view', class: '' },
        { label: 'Cnit/Mine non validés', sortable: true, sorted: '', key: 'cnit_mine_counter', class: '' },
        { label: 'Statut', sortable: true, sorted: '', key: 'status_document_label', class: '' },
        { label: '', sortable: false, sorted: '', key: '', class: '' },
      ],
    };
  },
  computed: {
    ...mapState({ counter: state => state.documents.counter }),
    ...mapState({ documents: state => state.documents.documents }),
    ...mapState({ energies: state => state.documents.energies }),
    ...mapState({ loading: state => state.documents.loading }),
    ...mapState({ status: state => state.documents.status }),
    ...mapState({ types: state => state.documents.types }),
  },
  methods: {
      async handleExport() {
      this.searchData['brand'] = this.brand;
      this.searchData['cnit'] = this.cnit;
      this.searchData['cnit_mine_status'] = this.cnit_mine_status;
      this.searchData['document_id'] = this.document_id;
      this.searchData['document_type'] = this.document_type;
      this.searchData['energy'] = this.energy;
      this.searchData['gearbox_type'] = this.gearbox_type;
      this.searchData['ktype'] = this.ktype;
      this.searchData['motor_type'] = this.motor_type;
      this.searchData['status_document'] = this.status_document;
      this.searchData['version'] = this.version;
	  this.searchData['gearbox_adapt'] = this.gearbox_adapt;
      this.searchData['motor_adapt'] = this.motor_adapt;


      this.dataOnGoing = true;
      const orderBy = this.getOrders();
      orderBy.map(order => {
        this.cols.find(col => { if (col.key === order.key) col.sorted = order.order; });
      });


      let data = await this.$store.dispatch('exportDocument', {
        page: 1,
        limit: 100000,
        brand: this.searchData.brand,
          cnit: this.searchData.cnit,
          cnit_mine_condition: this.searchData.cnit_mine_status,
          document_id: this.searchData.document_id,
          document_type_id: this.searchData.document_type,
          energy: this.searchData.energy,
          gearbox_type: this.searchData.gearbox_type,
          ktype: this.searchData.ktype,
          motor_type: this.searchData.motor_type,
          status_document_id: this.searchData.status_document,
          version: this.searchData.version,
		  gearbox_adapt: this.searchData.gearbox_adapt,
          motor_adapt: this.searchData.motor_adapt,
          orderBy: this.$route.query.orderBy ? Array.isArray(this.$route.query.orderBy) ? this.$route.query.orderBy : [ this.$route.query.orderBy ] : [ 'Document.updatedAt|DESC' ]
      });
      if (data) {
        const date = new Date();
        this.download.href ='data:attachment/csv;charset=utf-8,' + encodeURIComponent(data);
        this.download.file =`documents-${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}.csv`;

        this.$modal.show('download', {});
      }
      // this.$store.commit('setSpinner', false);
      this.dataOnGoing = false;
    },
    /* Modal */
    showModal(id) {
      this.$modal.show('removeDocument', { id: id });
    },
    beforeOpen(e) {
      this.documentId = e.params.id;
    },
    closeModal() {
      this.$modal.hide('removeDocument');
    },
    /* -- Buttons & forms in searchcard -- */
    handleResetFilter() {
      this.brand = '';
      this.cnit = '';
      this.cnit_mine_status = '';
      this.document_id = '';
      this.document_type = '';
      this.energy = '';
      this.gearbox_type = '';
      this.ktype = '';
      this.motor_type = '';
      this.status_document = '';
      this.version = '';
	  this.gearbox_adapt = '';
      this.motor_adapt = '';

      // FIXME : reset search object
    },
    async handleFilterResults() {
      this.searchData['brand'] = this.brand;
      this.searchData['cnit'] = this.cnit;
      this.searchData['cnit_mine_status'] = this.cnit_mine_status;
      this.searchData['document_id'] = this.document_id;
      this.searchData['document_type'] = this.document_type;
      this.searchData['energy'] = this.energy;
      this.searchData['gearbox_type'] = this.gearbox_type;
      this.searchData['ktype'] = this.ktype;
      this.searchData['motor_type'] = this.motor_type;
      this.searchData['status_document'] = this.status_document;
      this.searchData['version'] = this.version;
	  this.searchData['gearbox_adapt'] = this.gearbox_adapt;
      this.searchData['motor_adapt'] = this.motor_adapt;


      this.filterOnGoing = true;
      await this.getData(true, false);
      this.filterOnGoing = false;
    },
    /* -- Table actions -- */
    /* Returns ba-state-label color depending on its value */
    getStatusColor(status) {
      if (status == 'Validé') return 'success';
      return 'pending';
    },
    /* Image for error case */
    defaultImage(e) {
      e.target.src = 'https://cdn.activcar.fr/media/64/brands/default.png';
    },
    /* Get document motors & gearboxes */
    getTypeAdaptability(adap) {
      // const typeArray = (type && type.length) ? type.split(',') : [];
      const adapArray = (adap && adap.length) ? adap.split(',') : [];
      // const text = adapArray.length ? typeArray.concat(adapArray) : typeArray;
      return adapArray;
    },
    /* Get brand image */
    handleGetBrandImage(brand) {
      let text = brand.split(/[ -]+/)[0].toLowerCase();
      if (text == 'citroën') { text = 'citroen'; }
      if (text == 'vw') { text = 'volkswagen'; }
      if (text == 'land') { text = 'rover'; }
      if (text == 'bedford') { text = 'vauxhall'; }
      return `https://cdn.activcar.fr/media/64/brands/${text}.png`;
    },
    async handleUpdateDocumentStatus(id, status) {
      if(!this.accessValidFicheArticle) {
        return
      }
      if (id) {
        const data = await this.$store.dispatch('updateDocument', {
          id: id,
          status_document_id: status
        });
        if (data && data.id) {
          if (status == 1) this.$store.dispatch('displaySnackbar', { text: "La fiche article est validée", mode: '' });
          if (status == 2) this.$store.dispatch('displaySnackbar', { text: "La fiche article n'est plus validée", mode: '' });
          // Reload data list depending on search with filters or with matriculation
          this.getData(true, this.matriculationSearch ? true : false);
        } else {
          this.$store.dispatch('displaySnackbar', { text: "Une erreur est survenue. Veuillez réessayer", mode: 'error' });
        }
      }
    },
    async handleRemoveDocument() {
      if (this.documentId !== false) {
        const data = await this.$store.dispatch('deleteDocument', {
          id: this.documentId,
          page: this.currentPage,
          limit: Number(this.$store.getters.getLimit)
        });
        if (data) {
          this.$store.dispatch('displaySnackbar', { text: "La fiche article a été supprimée", mode: '' });
        }
        // Reload list of documents & keep filter active
        await this.getData(false, this.matriculationSearch ? true : false);
        this.closeModal();
      }
    },
    // async handleSearchMatriculation() {
    //   this.$store.dispatch('setLoading', true);
    //   if (this.matriculationSearch) {
    //     const data = await this.$store.dispatch('getVehicleByMatriculation', this.matriculationSearch);
    //     if (data && data.Aaa.ktype) {
    //       const associatedDocuments = await this.$store.dispatch('getDocumentsByKtype', {
    //         ktype: data.Aaa.ktype,
    //         motor_type: data.Aaa.motor_type,
    //         gearbox: data.Aaa.gearbox,
    //         vehicle_cnit: data.Aaa.cnit,
    //         vehicle_mine: data.Aaa.mine,
    //         page: 1,
    //         limit: Number(this.$store.getters.getLimit)
    //       });
    //       if (associatedDocuments && associatedDocuments.length) {
    //         this.documentsCount = associatedDocuments[0].counter;
    //       }
    //     }
    //   }
    //   this.$store.dispatch('setLoading', false);
    // },
    /* -- Paginate mixin -- */
    async getData(isNewSearch, isMatriculationSearch) {
      this.currentPage = isNewSearch ? 1 : this.currentPage;

      // Search from matriculation or with filters
      this.$store.dispatch('setLoading', true);
      if (isMatriculationSearch) {
        if (this.matriculationSearch) {
          const data = await this.$store.dispatch('getVehicleByMatriculation', this.matriculationSearch);
          if (data && data.Aaa.ktype) {
            const associatedDocuments = await this.$store.dispatch('getDocumentsByKtype', {
              ktype: data.Aaa.ktype,
              motor_type: data.Aaa.motor_type,
              gearbox: data.Aaa.gearbox,
              vehicle_cnit: data.Aaa.cnit,
              vehicle_mine: data.Aaa.mine,
              page: 1,
              limit: Number(this.$store.getters.getLimit)
            });
            if (associatedDocuments && associatedDocuments.length) {
              this.documentsCount = associatedDocuments[0].counter;
            }
          }
        } else {
          this.$store.dispatch('displaySnackbar', { text: "Veuillez entrer une immatriculation", mode: 'error' });
        }
      } else {
        const data = await this.$store.dispatch('getDocuments', {
          page: this.currentPage,
          limit: Number(this.$store.getters.getLimit),
          brand: this.searchData.brand,
          cnit: this.searchData.cnit,
          cnit_mine_condition: this.searchData.cnit_mine_status,
          document_id: this.searchData.document_id,
          document_type_id: this.searchData.document_type,
          energy: this.searchData.energy,
          gearbox_type: this.searchData.gearbox_type,
          ktype: this.searchData.ktype,
          motor_type: this.searchData.motor_type,
          status_document_id: this.searchData.status_document,
          version: this.searchData.version,
		  gearbox_adapt: this.searchData.gearbox_adapt,
          motor_adapt: this.searchData.motor_adapt,
          orderBy: this.$route.query.orderBy ? Array.isArray(this.$route.query.orderBy) ? this.$route.query.orderBy : [ this.$route.query.orderBy ] : [ 'Document.updatedAt|DESC' ]
        });
        if (data.length) {
          this.documentsCount = data[0].counter;
        } else {
          this.documentsCount = 0;
        }
      }
      this.$store.commit('setSpinner', false);
      this.$store.dispatch('setLoading', false);
    },
  },
  watch: generateSearchWatcher([
    'brand',
    'cnit',
    'cnit_mine_status',
    'document_id',
    'document_type',
    'energy',
    'gearbox_type',
    'ktype',
    'motor_type',
    'status_document',
    'version',
	'gearbox_adapt',
    'motor_adapt',

  ])
};
</script>

<style scoped>
/* Margin between searchcard, button & table */
.document-list .ba-search-card { margin-top: 1rem; }
.document-button { margin-top: 2rem; }
.document-list .ba-table { margin-top: 0.5rem; }

/* Form */
.document-list .matriculation-form {
  width: 50%;
  max-width: 10rem;
}

/* Table style */
.document-button div { font-weight: 500; }

.document-list img { width: 64px; }

/* Speedometer */
.document-list .speedometer {
  text-align: center;
  margin-top: 0.25rem;
}

/* Color icons */
.more .unValidate {
  color: var(--ba-state-pending-bg-color, rgb(249, 180, 0));
}

.more .validate {
  color: var(--ba-button-bg-secondary-hover, rgb(20, 141, 160));
}

.more .validate,
.more .unValidate {
  height:30px;
  width:30px;
}

/* Margin top pagination */
.mt12 {
    margin-top: 0.79rem;
  }
</style>
<style src="@/assets/styles/modals.css"></style>
<style src="@/assets/styles/paginations.css"></style>
<style src="@/assets/styles/tooltips.css"></style>
